import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from '../components/Hero';
import StatsBar from '../components/StatsBar';
import ServicesSection from '../components/ServicesSection';
import SubjectsSection from '../components/SubjectsSection';
import GoogleReviews from '../components/GoogleReviews';
import Testimonials from '../components/Testimonials';
import AreasAndProcess from '../components/AreasAndProcess';
import HowItWorks from '../components/HowItWorks';
import AboutUs from '../components/AboutUs';
import FAQ from '../components/FAQ';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://myhometutors.org/#organization',
      name: 'MyHomeTutors',
      url: 'https://myhometutors.org',
      logo: 'https://myhometutors.org/logo.png',
      telephone: '+919415905584',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'H.N 1/358, Vastu Khand, Gomti Nagar',
        addressLocality: 'Lucknow',
        addressRegion: 'Uttar Pradesh',
        postalCode: '226010',
        addressCountry: 'IN',
      },
      sameAs: ['https://www.google.com/maps?cid=6245695101345977885'],
    },
    {
      '@type': 'LocalBusiness',
      '@id': 'https://myhometutors.org/#localbusiness',
      name: 'MyHomeTutors Lucknow',
      description: 'Best home tuition service in Lucknow. Find verified tutors for Class 1–12, CBSE, ICSE, IIT-JEE, and NEET preparation.',
      url: 'https://myhometutors.org',
      telephone: '+919415905584',
      priceRange: '₹₹',
      openingHours: ['Mo-Sa 09:00-19:00', 'Su 10:00-16:00'],
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'H.N 1/358, Vastu Khand, Gomti Nagar',
        addressLocality: 'Lucknow',
        addressRegion: 'Uttar Pradesh',
        postalCode: '226010',
        addressCountry: 'IN',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: '26.8467',
        longitude: '80.9462'
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.9',
        reviewCount: '250',
        bestRating: '5'
      },
      areaServed: [
        'Gomti Nagar', 'Indira Nagar', 'Hazratganj', 'Mahanagar',
        'Aliganj', 'Jankipuram', 'Kalyanpur', 'Lucknow',
      ],
    },
    {
      '@type': 'WebSite',
      '@id': 'https://myhometutors.org/#website',
      url: 'https://myhometutors.org',
      name: 'MyHomeTutors – Best Home Tutors in Lucknow',
      description: 'Find verified home tutors in Lucknow for all classes and subjects.',
      publisher: { '@id': 'https://myhometutors.org/#organization' },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'How can I find the best home tutor in Lucknow near me?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'You can easily find qualified home tutors across Lucknow based on your location, class, and subject.'
          }
        },
        {
          '@type': 'Question',
          name: 'Is a free demo class available before hiring a tutor?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Yes, we offer a free demo class so you can evaluate the tutor before making a decision.'
          }
        },
        {
          '@type': 'Question',
          name: 'How quickly can I get a home tutor in Lucknow?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'In most cases, we can connect you with a suitable tutor within 24–48 hours after your request.'
          }
        },
      ],
    },
  ],
};

const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>Home Tutors Lucknow | Best Tuition Services - MyHomeTutors</title>
        <meta name="description" content="Find expert home tutors in Lucknow for Class 1-12, CBSE, ICSE, IIT-JEE, and NEET. Book a free demo class today." />
        <link rel="canonical" href="https://myhometutors.org/" />
        <meta property="og:title" content="Home Tutors Lucknow | Best Tuition Services - MyHomeTutors" />
        <meta property="og:description" content="Find expert home tutors in Lucknow for Class 1-12, CBSE, ICSE, IIT-JEE, and NEET. Book a free demo class today." />
        <meta property="og:url" content="https://myhometutors.org/" />
        <meta property="og:type" content="website" />
      </Helmet>
      
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeSchema) }}
      />
      
      <Hero />
      <StatsBar />
      <ServicesSection />
      <SubjectsSection />
      <GoogleReviews />
      <Testimonials />
      <AreasAndProcess />
      <HowItWorks />
      <AboutUs />
      <FAQ />
    </>
  );
};

export default HomePage;